import { palette } from '../palette';

export const MuiTab = {
  styleOverrides: {
    root: {
      borderRadius: '8px 8px 0px 0px',
      color: palette.custom.gray[500],
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '12px',
      paddingRight: '12px',
      fontSize: '14px',
      lineHeight: '20px',
      textTransform: 'none',
      fontWeight: 600,
      marginRight: '4px',
      height: '32px',
      minHeight: '32px',
      '&:hover':{
        backgroundColor: palette.custom.gray[100],
      },
      '&.Mui-selected': {
        color: palette.primary[700],
        backgroundColor: palette.custom.gray[50],
        fontWeight: 600,
        '&:hover':{
          color: palette.custom.gray[800],
          backgroundColor: palette.custom.gray[100],
        },
      },
    },
  },
};

export const MuiTabs = {
  defaultProps: {
    scrollButtons: 'auto',
    allowScrollButtonsMobile: true,
  },
  styleOverrides: {
    root: {
      borderBottom: '1px solid',
      borderColor: palette.custom.gray[200], 
      height: '32px',
      minHeight: '32px',
    },
    indicator: {
      // display: 'none',
    },
  },
};